import _GearFilledIcon from "@adsk/alloy-react-icon/es/lib/GearFilledIcon";
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/alloy-react-button';
import { stylePropType } from '@adsk/alloy-react-theme';
const TableConfigurationButton = _ref => {
  let {
    onClick,
    style
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    "data-testid": 'TableConfigurationButton',
    variant: Button.VARIANTS.TERTIARY,
    size: Button.SIZES.SMALL,
    style: [{
      color: 'inherit',
      padding: 0
    }, style]
  }, /*#__PURE__*/React.createElement(_GearFilledIcon, {
    size: 20
  }));
};
TableConfigurationButton.propTypes = {
  onClick: PropTypes.func,
  style: stylePropType
};
export default TableConfigurationButton;
//# sourceMappingURL=Button.js.map